import React from 'react';

type MultipleEditFirstStepTitleProps = {
  className: string;
};

export default function MultipleEditFirstStepTitle({ className }: MultipleEditFirstStepTitleProps): JSX.Element {
  return <div className={className}>Edit Multiple</div>;
}
